"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = require("gsap");
const THREE = __importStar(require("three"));
const Util_1 = __importDefault(require("../../Util"));
class Flower extends THREE.Object3D {
    constructor() {
        super();
        this.petals = [];
        this.container = null;
        this.velocity = new THREE.Vector3();
        this.acceleration = new THREE.Vector3();
        this.isUpdate = false;
        this._create();
        this._reset();
    }
    draw() {
        this.isUpdate = true;
        this.petals.forEach((petal, i) => {
            petal.draw(i * 0.07);
        });
    }
    _reset() {
        this.position.z = 0;
        this.petals.forEach(petal => petal.reset());
        this.velocity.set(0, 0, 0.001);
        this.acceleration.set(0, 0, 0.0006);
    }
    update() {
        if (!this.isUpdate)
            return;
        this.rotation.z -= 0.02;
        this.velocity.add(this.acceleration);
        this.position.add(this.velocity);
        if (this.position.z > 8) {
            this._reset();
            this.draw();
        }
    }
    hide(cb) {
        this.isUpdate = false;
        gsap_1.gsap.to(this.position, {
            duration: Util_1.default.map(this.position.z, 0, 8, 2, 0.8),
            z: 9,
        });
        this.petals.forEach((petal, i) => {
            petal.stop();
        });
        gsap_1.gsap.delayedCall(2, () => {
            cb();
        });
    }
    _create() {
        this.container = new THREE.Object3D();
        this.container.rotation.x = Math.PI / 2;
        this.add(this.container);
        for (let i = 0; i < 50; i++) {
            const dist = i / 16 + 0.6;
            const x = Math.cos(i) * dist;
            const z = Math.sin(i) * dist;
            const size = Util_1.default.random(1.2, 1.5);
            const petal = new Petal(size, size);
            petal.position.set(x, 0, z);
            this.container.add(petal);
            this.petals.push(petal);
        }
    }
}
exports.default = Flower;
class Petal extends THREE.Object3D {
    constructor(width = 1, height = 1) {
        super();
        this.vs = `
      varying float v_z;
    
      #define PI 3.14159265359
      uniform float u_offset;
      uniform float u_progress;
      uniform float u_direction;
      uniform float u_time;
      uniform float u_waveIntensity;
    
      void main() {
    
        float maxDistance = distance(vec2(0.), vec2(0.8));
        float dist = distance(vec2(0.), uv-0.5);
        float activation = smoothstep(0., maxDistance, dist);
        float startAt = activation * 1.; // 시작 시간은 uv 위치에 따라 달라지게 구현 ( u_progress에서 타이밍을 다르게 조절 )
        float vertexProgress = smoothstep(startAt, 1., u_progress); // 위치값의 progress
        vec2 scale = vec2(1. + .5 * vertexProgress);
        vec3 pos = position;
        pos.xy *= scale;
        pos.z = (scale.x - 1.0) * 20.;
    
        v_z = pos.z / 5.;
    
        gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
      }
    `;
        this.fs = `
      precision mediump float;
      varying float v_z;
    
      void main() {
        
        float c = smoothstep(0.0, 0.4, v_z);
        vec3 color = vec3(c);
        gl_FragColor = vec4(color, 1.0);
      }
    `;
        this.width = width;
        this.height = height;
        this.wireframe = null;
        this.shape = null;
        this.uniforms = {
            u_progress: { value: 0.0 },
            u_time: { value: 0.0 },
            u_offset: { value: 0 },
            u_direction: { value: 1 },
            u_waveIntensity: { value: 0.1 },
        };
        this._createShape();
    }
    draw(delay = 0) {
        gsap_1.gsap.to(this.uniforms.u_progress, {
            delay: delay,
            duration: 1,
            value: 0.3,
        });
    }
    reset() {
        gsap_1.gsap.killTweensOf(this.uniforms.u_progress);
        this.uniforms.u_progress.value = 0;
    }
    stop() {
        gsap_1.gsap.killTweensOf(this.uniforms.u_progress);
        gsap_1.gsap.to(this.scale, { duration: 1, x: 5, y: 5, z: 5 });
    }
    update() {
    }
    _createShape() {
        const geo = new THREE.PlaneBufferGeometry(this.width, this.height, 20, 20);
        const mat = new THREE.ShaderMaterial({
            vertexShader: this.vs,
            fragmentShader: this.fs,
            uniforms: this.uniforms,
            transparent: true,
            side: THREE.DoubleSide,
        });
        this.shape = new THREE.Mesh(geo, mat);
        this.shape.rotation.x = -Math.PI / 2;
        this.add(this.shape);
    }
    _createWireframe() {
        this.wireframe = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1), new THREE.MeshBasicMaterial({ color: 0xff0000, wireframe: true }));
        this.add(this.wireframe);
    }
}
